<app-navbar></app-navbar>
<div class="content">
  <div class="page-header">
    <h2 itemprop="headline">
      HuiosPay Privacy Policy <br />
      Effective Date: September 2023
    </h2>
  </div>
  <div itemprop="articleBody">
    <span style="color: #686868"><b>Introduction</b></span>

    <p>
      HuiosPay Limited is a leading financial technology (FinTech) payment
      processing company in Nigeria with emphasis on creating cutting edge
      innovative solutions in facilitating safe, transparent and secured
      electronic payment solutions (payment solutions services, payment terminal
      services) for businesses in Nigeria. Our Offices are located at No 28
      Adetokunbo Ademola Crescent, Wuse 2 Abuja.RC No.1855526 <br />
      HuiosPay is committed to protecting the privacy of your personal data.
      This Privacy Policy explains how we collect, use, and disclose your
      personal data when you use our website, mobile applications, and other
      services.
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Objective</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >This Privacy Policy enlightens users about their privacy rights
        regarding our collection, use, storage, sharing and protection of
        personal information.It applies to the HuiosPay website and other
        related sites, applications, services and tools regardless of how they
        are accessed or used.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>What is Personal Information or Data?</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >Personal information or data refers to any information that can be used
        to identify an individual, such as their name, address, phone number,
        email address, date of birth, identification documents and financial
        information<br />
        Personal data is defined according to the Nigerian
        <a href="data-protection"
          >Data Protection Regulation/General Data Protection </a
        >Regulation as: <br /><br />
        <i
          >“Any information relating to an identified or identifiable natural
          person; an identifiable natural person is one who can be identified,
          directly or indirectly, in particular by reference to an identifier
          such as name, an Identification number, location data, an online
          identifier or to one or more factors specific to the physical,
          physiological, genetic, mental economic, cultural or social identity
          of that natural person.”</i
        ><br />
        <br />
        HuiosPay Privacy Policy is in compliance with industry regulations; it
        provides information on how data is securely collected, processed and
        stored in a responsible and sustainable manner. <br />
        This privacy policy will explain how our organization uses the personal
        data we collect from our customers and related partners when they use
        any of our platforms or subscribe to any of our services and products.
      </span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>Collection of Personal Information</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >To ensure smooth transactions we require personal identifiable
        information/data popularly known as KYC (Know Your Customer). This
        information is specific to an individual. These include email, address,
        phone number, date of birth, name e.t.c</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>What Personal Data Do We Collect and How it is Collected?</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We collect the following types of personal data from you; data could be
        collected either electronically (automatically) or manually:</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <b>Information you provide to us: </b>
      <span style="color: #646464"
        >We collect personal data that you provide to us when you create an
        account, use our Services, or contact us for customer support. This may
        include your name, address, phone number, email address, date of birth,
        and financial information.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <b>Information we collect automatically: </b>
      <span style="color: #646464">
        We automatically collect certain non-personal data when you use our
        Services, such as your IP address, device type, browser type, and
        referring URL.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <b>Information from third parties: </b>
      <span style="color: #646464">
        We may collect personal data about you from third parties, such as
        credit bureaus ,social media platform or other financial service
        providers and other related agencies.
      </span>
    </p>
    <p style="text-align: justify" align="justify">
      <b>Information collected manually: </b>
      <span style="color: #646464">
        we may collect customer’s data when they visit our physical locations
        for inquiries or enter data manually for our services and products. We
        may collect customers’ data through our customer services platforms
        which includes phone calls, emails, social media and other communication
        medium.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Usage of Information</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >The main purpose of data collection is to ensure the provision of a
        seamless, reliable, efficient and secure customer experience; with the
        aim of exceeding customer service excellence and achieving each
        individual customer’s needs. We also collect information which aids in
        ensuring and enhancing customer service experience specific to each
        customer, for purpose of credit checks and accuracy of information.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>How Do We Use Your Personal Data?</b></span
      >
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We use your personal data for the following purposes:</span
      >
    </p>

    <p style="text-align: justify" align="justify">
      <b>To provide you with our Services: </b>
      <span style="color: #646464">
        We use your personal data to provide you with our Services, such as
        processing payments, opening accounts, and providing customer support.
        HuiosPay may send notifications (alerts) about transactions, verifying
        identity, account creation/maintenance and other auxiliary services
        (passwords, dispute resolution challenges, fraud prevention, policy
        violation detection/prevention, troubleshooting e.t.c)
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <b>To send you marketing communications: </b>
      <span style="color: #646464">
        We may use your personal data to send you marketing communications, such
        as emails and promotional offers.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <b>Personalizing your experience: </b>
      <span style="color: #646464">
        We use cookies to personalize your experience on our Services. For
        example, we may use cookies to remember your preferences, such as your
        language preference and location.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <b>To protect our business: </b>
      <span style="color: #646464">
        We use your personal data to protect our business, such as by preventing
        fraud and detecting and investigating security breaches.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>How Do We Disclose or Share Your Personal Data?</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868">
        We may disclose or share your personal information or data with other
        HuiosPay Users and Other third parties:
      </span>
    </p>

    <!-- <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>How can I control cookies? </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        >You can control cookies in a number of ways, including:</span
      >
    </p> -->

    <!-- <p style="text-align: justify" align="justify">
      <span style="color: #686868">Cookies can be divided into: </span>
    </p> -->
    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          ><b>Members of the HuiosPay Team: </b> To provide joint content,
          products, and services (such as registration, transactions and
          customer support), to help detect and prevent potentially illegal acts
          and violations of our policies, and to guide decisions about their
          products, services, and communications. This information will only be
          used for marketing communications only, if customers have requested
          for the services.</span
        >
      </li>
      <li>
        <span style="color: #686868"
          ><b>Financial institutions: </b>
          That we partner with to jointly create and offer a product may only
          use this information to market HuiosPay related products, unless
          customer has given consent for other uses.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>Credit bureaus and collection agencies: </b> To report account
          information, as permitted by law.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>Banking partners:</b> As required by credit/debit card association
          rules for inclusion on their list of terminated merchants.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>Companies:</b> That we plan to merge with or are acquired by.
          (Should such a combination occur, we will require that the new
          combined entity follow this Privacy Policy with respect to customer
          personal information. Customer will receive prior notice if personal
          information would be used contrary to this policy).
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b
            >Law enforcement, government officials, or other third parties
            Agencies:
          </b>
          pursuant to a subpoena, court order, or other legal process or
          requirement applicable to HuiosPay or one of its affiliates; We may
          disclose your personal data to law enforcement agencies if we are
          required to do so by law or in complying with law or credit/debit card
          rules. if we believe that it is necessary to protect our rights or the
          rights of others. Also, in our sole discretion, that the disclosure of
          personal information is necessary to prevent physical harm or
          financial loss, to report suspected illegal activity or to investigate
          violations of our User Agreement.
        </span>
      </li>
    </ul>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868">
        HuiosPay may share your personal information with other third parties in
        certain circumstances or/and for the following purposes:
      </span>
    </p>

    <ol style="text-align: justify; list-style-type: lower-roman">
      <li>
        <span style="color: #686868"
          ><b>Fraud Prevention and Risk Management: </b> To help prevent fraud
          or assess and manage risk.</span
        >
      </li>
      <li>
        <span style="color: #686868"
          ><b>Customer Service: </b>
          For customer service purposes, including to help service your accounts
          or resolve disputes.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>Shipping: </b> In connection with shipping and related services
          for purchases made using HuiosPay Services.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>Legal Compliance:</b> To help them comply with anti-money
          laundering, counter-terrorist financing verification requirements and
          the Central Bank of Nigeria regulations on Know Your Customer (KYC).
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>Service Providers: </b> We may disclose your personal data to
          service providers who help us to provide our Services, such as payment
          processors and cloud hosting providers to enable them under contract
          with us to support our business operations, such as fraud prevention,
          bill collection, marketing, customer service, address verification and
          technology services. Our contracts dictate that these service
          providers only use customer information in connection with the
          services they perform for us and not for their own benefit.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b
            >With your consent or direction to do so to other third parties.
          </b>
          <ol style="text-align: justify; list-style-type: lower-alpha">
            <li>
              <span style="color: #686868">
                Kindly note that these third parties may be in other countries
                where the laws on processing personal information may be less
                stringent than in our country of primary jurisprudence.
              </span>
            </li>
            <li>
              <span style="color: #686868">
                We will not be liable to or for the use of any of our products
                and services on a third-party website or application except we
                state otherwise. Any information that are entered on such
                systems (and not directly on an HuiosPay platforms) will be
                shared with the owner of the third-party website or application.
                These sites are having their own privacy policies and customers
                are encouraged to review their privacy policies before providing
                them with personal information. HuiosPay is not responsible for
                the content or information practices of such third parties.
              </span>
            </li>
          </ol>
        </span>
      </li>
    </ol>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>Protection And Storage of Personal Information</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Your personal information is securely stored as required by the Central
        bank of Nigeria and other Authorities at our office. Information are
        protected with high level of security to prevent, reduce the risks of
        loss, misuse, abuse, unauthorized access and possession, disclosure and
        malicious damage, destruction, theft, alteration and data harvest.
        <br />
        We use PCI DSS firewalls protocols and encryption for file and data, and
        full implementation of data access and control practice, data handler
        identification policy and information access authorization controls. We
        have also taken additional measures by ensuring our system complies with
        industry information security standards.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Marketing</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We do not sell or rent your personal information to third party for
        their marketing promotions. We may combine customer’s information from
        our database with that collected from other companies and use it to
        improve HuiosPay Services, platforms, and advertisements. We have also
        included options for customers that had initially subscribed to
        receiving notifications or information about our products and services
        to opt out, unsubscribe or request to be removed from applicable
        database. If you have any questions about this Cookies Policy, please
        contact us at

        <!-- <a href="mailto:contactus@huiospay.com">[contactus@huiospay.com]</a> -->
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Customer Data Protection Rights</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Our customers have inalienable data protection rights and are entitled
        to the following:
      </span>
    </p>

    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          ><b>The right to access your personal data– </b> Customer have the
          right to request for copies of their personal data that we hold.
          HuiosPay may charge a fee for this service
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>The right to rectification of inaccurate personal data – </b>
          Customers have the right to: request that HuiosPay rectifies any
          information they believe and have proven have been captured
          inaccurately. Customers also have the right to request HuiosPay to
          complete the information they believe is incomplete.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>The right to erasure of your personal data– </b> Customers have
          the right to: request that HuiosPay erases their personal data, under
          certain conditions. These conditions are not limited to regulatory
          requirements, law enforcement agencies, or where such action may cause
          disruption to our system.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>The right to restrict processing of your personal data– </b>
          Customers have the right to: request that HuiosPay restricts the
          processing of their personal data, under certain conditions.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>The right to object to processing of your personal data– </b>
          Customers have the right to object to HuiosPay processing of your
          personal data, under certain conditions.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>The right to data portability – </b>
          Customers have the right to: request to receive your personal data
          that HuiosPay may have collected in a structured, commonly used, and
          machine-readable format and to have it transmitted to another
          controller/organization, or directly to them, under certain
          conditions.
        </span>
      </li>
    </ul>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>How to Exercise Your Rights</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        To exercise any of your rights, please contact us at
        <a href="mailto:contactus@huiospay.com "> contactus@huiospay.com </a>
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>Cookies and Similar Technologies</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We use cookies and similar technologies to enhance your experience on
        our website and improve our services. You can manage your cookie
        preferences through your browser settings. For detailed information on
        the cookies and how we use them see our
        <a href="cookies-Policy"> Cookie Policy. </a>
      </span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Third-Party Links</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Our website may contain links to third-party websites. We are not
        responsible for the privacy practices or content of these third-party
        sites.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Data Security</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We have implemented appropriate security measures to protect your
        personal data from unauthorized access, use, disclosure, alteration, or
        destruction. These measures include:
      </span>
    </p>

    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          ><b>Physical security measures: </b> We have implemented physical
          security measures to protect our data centres, including access
          control systems and security cameras.</span
        >
      </li>
      <li>
        <span style="color: #686868"
          ><b>Technical security measures: </b>We have implemented technical
          security measures to protect our data, such as encryption and
          firewalls.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>Organizational security measures: </b> We have implemented
          organizational security measures to protect our data, such as data
          breach reporting procedures and employee training.
        </span>
      </li>
    </ul>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Data Retention</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We will retain your personal data for no longer than is necessary for
        the purposes for which it was collected. Customer request based on any
        of the rights above shall be handled within a reasonable time. Customer
        may contact us by email
        <a href="contact-us">(contactus@huiospay.com)</a> or our phone lines.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Remedies</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Upon becoming aware of any violation of the Policy, the company shall
        assess the depth of the violation and take all available action to
        remedy, modify, correct and any and all other actions as available
        according to the law. This may be done reasonably within 30 days.
      </span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Remedies</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Upon becoming aware of any violation of the Policy, the company shall
        assess the depth of the violation and take all available action to
        remedy, modify, correct and any and all other actions as available
        according to the law. This may be done reasonably within 30 days.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>Privacy Policy Changes And Privacy</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We may update this Privacy Policy from time to time as our Privacy
        Policies are reviewed periodically in line with current regulations and
        developments in the industry. We will notify you of any material changes
        by posting the updated Privacy Policy on our website and our various
        platforms. <br />Whenever your personal information is collected, we
        would inform you of your rights and channels available to exercise your
        rights. Alternatively, we also let you manage how much information you
        wish or choose to share.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>Compliance With Nigeria Data Protection Regulation (NDPR)</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We comply with the Nigeria Data Protection Regulation (NDPR) and other
        applicable data protection laws.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Consent</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Your consent to our Privacy Policy is implied once you make use of any
        of our products or services on any of our platforms although your
        consent will often be sought before usage. (websites, contents,
        technologies, etc.) <br />
        It is important to note that consent can be explicitly withdrawn at any
        given time through appropriate channels and services will cease or be
        stopped. Consent and withdrawal for those below 18 or those legally
        unfit or otherwise must be by the appropriate person.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Additional Information</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Customer Data Protection Rights are preserved. This Privacy Policy
        without an explicit contract, governs the use of HuiosPay Services by
        users. For more detailed information on how we process your personal
        data, please refer to our
        <a href="data-protection">data Protection</a> Notice.
      </span>
    </p>
    <p align="justify"></p>
    <p align="justify">
      <span style="color: #686868"><b>Contact Us</b></span>
    </p>
    <p align="justify" style="margin-bottom: 100px">
      <span style="color: #686868"
        >If you have concerns or any questions about this Privacy Policy,and
        would like to exercise your protection rights;<br> Please contact us at
        <a href="mailto:contactus@huiospay.com">contactus@huiospay.com</a> or <a href="mailto:privacy@huiospay.com">privacy@huiospay.com</a>.<br> Our Customer Contact
        Centre :+234(0) 8037086670 |(0) 8096247247 <br>
      &COPY;2023 HuiosPay
      </span>
    </p>
  </div>
</div>
<app-footer></app-footer>
